import Modal from "../../shared/Modal";
import Button from "../../shared/Button";

const RateDeleteModal = ({ visible, setVisible, submit, loading }) => {
  function handleCancelModal() {
    setVisible(false);
  }

  const modalFooter = (
    <>
      <Button onClick={handleCancelModal} type="alternative">
        Cancel
      </Button>
      <Button
        loading={loading}
        disabled={loading}
        onClick={submit}
        type="primary"
      >
        Confirm
      </Button>
    </>
  );

  const modalContent = (
    <div className="">Are you sure you want to delete this rate?</div>
  );

  return (
    <Modal
      visible={visible}
      setVisible={setVisible}
      onClose={() => setVisible(false)}
      title="Delete Rate"
      footer={modalFooter}
      content={modalContent}
      size="md"
      footerPosition="right"
    />
  );
};

export default RateDeleteModal;
